import apis from "../../core/apis";
import isNil from "lodash/fp/isNil";
import { saveAs } from "file-saver";
class Controller {
  constructor($injector, Events, Upload, Sections, $stateParams, $state) {
    "ngInject";

    this.Events = Events;
    this.Upload = Upload;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.sections = Sections.settingsSections;
    this.Lists = $injector.get("Lists");
    this.categories = this.Lists.all.bulkScriptsCategories;
    this.BulkScripts = $injector.get("BulkScripts");
    this.showSuccessNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.clear = () => {
      delete this.file;
    };
    // Initialize selectedAction
    if (this.$stateParams.action) {
      this.selectedAction = this.$stateParams.action;
      this.getFileTemplate(this.selectedAction);
    }
  }

  uploadCSV() {
    if (!isNil(this.file) && !isNil(this.selectedAction)) {
      this.isUploading = true;
      const data = {
        document: this.file,
      };
      this.Upload.upload({
        url: `${apis.bulkScripts}?action=${this.selectedAction}`,
        data,
      }).then(
        () => {
          this.Events.emit(this.showSuccessNotificationEvent, {
            message:
              "Your file has been uploaded successfully, You will receive an email shortly",
          });
          this.isUploading = false;
          delete this.file;
          delete this.selectedAction;
        },
        (response) => {
          const message = response.data.message || "Can't upload your file !";

          this.Events.emit(this.errorEvent, { message });
          this.isUploading = false;
        }
      );
    }
  }

  // Empty: if true, means that the data will provide only the fields(columns) else columns and rows
  downloadCSVTemplate(data, empty) {
    const newRowRegex = "\r\n";
    const columns = !empty
      ? Object.keys(data[0]).join(",") + newRowRegex
      : data.join(",") + newRowRegex;
    const rows = !empty
      ? data.reduce((rows, row) => {
          return rows.concat(Object.values(row).join(",") + newRowRegex);
        }, "")
      : "";
    const parsedData = columns + rows;
    const csvFile = new File(
      [parsedData],
      `${
        this.categories.find((selectedAction) => {
          return selectedAction.name === this.selectedAction;
        }).title
      }.csv`
    );
    saveAs(csvFile);
  }

  getFileTemplate(type) {
    this.$state.go(".", { action: type });
    this.BulkScripts.getTemplate({
      action: type,
      isCityRequired: false,
    }).$promise.then(
      (response) => {
        this.canDownloadTemplate = true;
        this.csvColumns = response.fields;
      },
      (error) => {
        this.Events.emit(this.errorEvent, error.data);
      }
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/bulkScriptsUpload/bulkScriptsUpload.controller.js